import { ApiRoutes } from "../common/apiRoutes";
import Http from "../services/http";

// List of staff get from here :
export const getStaffList = (search: string, role_id: string,sortField:any,sortDirection:any) => {
  return Http.get(`${ApiRoutes.staff}?search=${search}&role_id=${role_id}&sort_by=${sortField}&sort_direction=${sortDirection}`);
};

// For add staff :
export const postStaffDetail = (payload: any) => {
  return Http.post(ApiRoutes.staff, payload);
};

// Get staff detail by Id :
export const getStaffDetailById = (id: string) => {
  return Http.get(`${ApiRoutes.staff}/${id}`);
};

// For update the staff detail with Id :
export const updateStaffDetailWithId = (id: string, payload: any) => {
  return Http.put(`${ApiRoutes.staff}/${id}`, payload);
};

// Delete the staff record using Id :
export const deleteStaffRecord = (id: any) => {
  return Http.delete(`${ApiRoutes.staff}/${id}`);
};